import { DMVStoreService } from "../dmv/dmv-store.service";
import { AppUtil } from "./../../utils/app.util";
import * as i0 from "@angular/core";
import * as i1 from "../dmv/dmv-store.service";
export class GoogleMapsConfig {
    constructor(dmvStoreService) {
        this.dmvStoreService = dmvStoreService;
        AppUtil.log("INSIDE MAPs"); //This is not displayed in console
        dmvStoreService.agencyConfigData$.subscribe(agencyConfigData => {
            if (agencyConfigData &&
                agencyConfigData.agencyDmvConfig &&
                agencyConfigData.agencyDmvConfig.mapAPIKey) {
                AppUtil.log("agencyConfigData.agencyDmvConfig.mapAPIKey :" +
                    agencyConfigData.agencyDmvConfig.mapAPIKey);
                this.apiKey = agencyConfigData.agencyDmvConfig.mapAPIKey;
            }
        });
    }
}
GoogleMapsConfig.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GoogleMapsConfig_Factory() { return new GoogleMapsConfig(i0.ɵɵinject(i1.DMVStoreService)); }, token: GoogleMapsConfig, providedIn: "root" });
